import { isDefined } from "@clipboard-health/util-ts";
import { formatDollarsAsUsd } from "@src/appV2/lib/Money/utils/currency";

import { type ModalShiftAuctionData, type ShiftFormattedPayBreakdown } from "./types";

export function getFormattedShiftPayBreakdown(
  offerPay?: number,
  finalPay?: number,
  // eslint-disable-next-line @typescript-eslint/ban-types
  originalAmount?: number | null,
  shiftBoost?: number
): ShiftFormattedPayBreakdown | undefined {
  const hourlyPayValue = offerPay ?? finalPay;

  if (!isDefined(hourlyPayValue)) {
    return undefined;
  }

  if (!isDefined(originalAmount)) {
    return undefined;
  }

  return {
    totalPay: formatDollarsAsUsd(originalAmount),
    hourlyPay: formatDollarsAsUsd(hourlyPayValue),
    ...(isDefined(shiftBoost) && {
      totalWithBoostPay: formatDollarsAsUsd(originalAmount + shiftBoost),
    }),
  };
}

export function getFormattedShiftPayBreakdownWithShiftAuction(
  shiftAuction: Pick<ModalShiftAuctionData["attributes"], "minimumPay" | "maximumPay">
): ShiftFormattedPayBreakdown | undefined {
  const minimumPay = shiftAuction.minimumPay.amountInMinorUnits / 100;
  const maximumPay = shiftAuction.maximumPay.amountInMinorUnits / 100;

  return {
    totalPay: "Bid to Win",
    hourlyPay: `${formatDollarsAsUsd(minimumPay)} - ${formatDollarsAsUsd(maximumPay)}`,
  };
}
